export interface RoleUi {
  Name?: string;
  Description?: string;
  RoleCode?: string;
  Code: string;
  Actions: string[];
}
export interface UiDefinition {
  Code: string;
  Name: string;
  Path: string;
  Legacy: string;
  Actions: string[];
}
export const RoleUiCatalogue: UiDefinition[] = [
  {
    Code: "Dashboard",
    Name: "Dashboard",
    Path: "/dashboard",
    Legacy: "Dashboard.View",
    Actions: [],
  },
  ...[
    ["Product", "Products", "/products"],
    ["Unit", "Units of measurement", "/units"],
    ["Category", "Categories", "/categories"],
    ["Customer", "Customers", "/customers"],
    ["Supplier", "Suppliers", "/suppliers"],
    ["Purchase", "Purchases", "/purchases"],
    ["Sale", "Sales", "/sales"],
    ["Order", "Orders", "/orders"],
    ["Income", "Income", "/income"],
    ["Expense", "Expenses", "/expenses"],
    ["Warehouse", "Warehouses", "/warehouses"],
    ["User", "Users", "/users"],
    ["Role", "Roles", "/roles"],
    ["Permission", "Permissions", "/permissions"],
  ].map(([Code, Name, Path]) => ({
    Code,
    Name,
    Path,
    Legacy: `${Code}.View`,
    Actions:
      Code === "Sale"
        ? ["Create", "Edit", "Delete", "PrintReceipt", "Return", "ApproveReturn"]
        : Code === "Purchase" ? ["Create", "Edit", "Delete", "Return", "ApproveReturn"] : ["Create", "Edit", "Delete"],
  })),
  {
    Code: "Inventory",
    Name: "Stock",
    Path: "/inventory",
    Legacy: "Inventory.View",
    Actions: ["Create", "Edit", "Delete"],
  },
  {
    Code: "InventoryCount",
    Name: "Stock counts",
    Path: "/inventory/counts",
    Legacy: "Inventory.Manage",
    Actions: ["Create", "Edit", "Delete", "Post"],
  },
  {
    Code: "InventoryMovement",
    Name: "Stock movement",
    Path: "/inventory/movements",
    Legacy: "Inventory.Manage",
    Actions: [],
  },
  {
    Code: "InventoryTransfer",
    Name: "Stock transfers",
    Path: "/inventory/transfers",
    Legacy: "Inventory.Manage",
    Actions: ["Create", "Edit", "Delete", "Post"],
  },
  {
    Code: "DailySales",
    Name: "Daily sales",
    Path: "/reports/daily-sales",
    Legacy: "Report.View",
    Actions: [],
  },
  {
    Code: "NotificationSetting",
    Name: "Notification settings",
    Path: "/settings/notifications",
    Legacy: "Notification.Manage",
    Actions: ["Edit"],
  },
  {
    Code: "NotificationLog",
    Name: "Notification logs",
    Path: "/notifications/logs",
    Legacy: "Notification.View",
    Actions: [],
  },
  {
    Code: "SmtpSetting",
    Name: "SMTP settings",
    Path: "/settings/smtp",
    Legacy: "Tenant.Manage",
    Actions: ["Create", "Edit", "Delete"],
  },
  {
    Code: "Tenant",
    Name: "Tenant settings",
    Path: "/tenant",
    Legacy: "Tenant.Manage",
    Actions: ["Edit"],
  },
];
export const actionLabel = (code: string) =>
  ({
    Create: "Create",
    Edit: "Edit",
    Delete: "Delete",
    PrintReceipt: "Print receipt",
    Complete: "Complete transfer",
    Return: "Initiate / edit returns",
    ApproveReturn: "Approve / reject returns",
  })[code] ?? code;
export const getRoleUiForPath = (path: string) =>
  RoleUiCatalogue.find((ui) => ui.Path === path);
export function mergeRoleUis(uis: RoleUi[]): RoleUi[] {
  const result = new Map<string, Set<string>>();
  for (const ui of uis) {
    if (!result.has(ui.Code)) result.set(ui.Code, new Set());
    for (const action of ui.Actions ?? []) result.get(ui.Code)!.add(action);
  }
  return [...result].map(([Code, Actions]) => ({
    Code,
    Actions: [...Actions],
  }));
}
